import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);
const testimonialSections = document.querySelectorAll(".testimonial-section");
testimonialSections.forEach((sliderSection, i) => {
  const slider = tns({
    container: sliderSection.querySelector(".slider"),
    items: 1,
    duration: 1000,
    // center: true,
    autoplay: true,
    mode: "gallery",
    controls: false,
    nav: false,
    //navContainer: sliderSection.querySelector('.team-slider-nav'),
    loop: true,
    autoplayButtonOutput: false,
    //controlsContainer: sliderSection.querySelector(".slider-controls"),
    fixedHeight: true,
  });
  slider.events.on("transitionStart", function (info) {
    // console.log("transitionStart", info);
    return;
    const text = sliderSection.querySelector(
      ".tns-slide-active h3"
    );
    let split = new SplitText(text, { type: "words,lines" });
    let lines = split.lines;
    gsap.fromTo(
      lines,
      {
        y: 100,
        duration: 0.5,
        ease: "power2.out",
      },
      {
        y: 0,
        duration: 0.5,
        ease: "power2.out",
      }
    );
  });
});
